export const getAuthorRssChannelUrl = (authorId: string) => `rss/author/${authorId}`

export const getCollectionRssChannelUrl = (authorId: string) => `rss/collection/${authorId}`
